import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY, MEMBER_KEY } from './keys';
import { UserGroupApi } from 'api';
import { IUserGroupTarget } from 'types';

function useGetTargets(id: number) {
  return useAuthQuery(
    getQueryKeys([KEY, MEMBER_KEY, 'TARGET']).detail(id),
    () => UserGroupApi.getTargets(id),
    {
      select: (data) =>
        data.data as { data: IUserGroupTarget[]; total: number },
      enabled: !!id,
    },
  );
}

export default useGetTargets;
